import { render, staticRenderFns } from "./SettingsStore.vue?vue&type=template&id=12afa344&"
import script from "./SettingsStore.vue?vue&type=script&lang=js&"
export * from "./SettingsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports